export enum ExecutionType {
    CloudFile = 1,
    OrderProcessing = 2,
    OrderDelivery = 3
}
